import React from 'react';
import { Box } from '@mui/material';
import TopNavigation from '../sections/TopNav/TopNav';
import Footer from '../sections/footer';
import MobileBottomNav, { NAV_HEIGHT } from '../components/MobileBottomNav';
import { useTheme } from '../providers/ThemeProvider';

interface LayoutProps {
  children: React.ReactNode;
}

function Layout(props: LayoutProps) {
  const { children } = props;
  const { colors } = useTheme();

  return (
    <Box sx={{ backgroundColor: colors.background, minHeight: '100vh' }}>
      <TopNavigation />
      <Box
        sx={{
          marginTop: '90px',
          // Add bottom padding on mobile to account for bottom nav + iOS safe area
          paddingBottom: {
            xs: `calc(${NAV_HEIGHT}px + env(safe-area-inset-bottom))`,
            md: 0,
          },
        }}
      >
        {children}
      </Box>
      <Footer />
      <MobileBottomNav />
    </Box>
  );
}

export default Layout;
